import React from 'react';

const GOLD_GRADIENT = (
  <linearGradient id="gold-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
    <stop offset="0%" stopColor="#fff8e7" />
    <stop offset="25%" stopColor="#ffd700" />
    <stop offset="50%" stopColor="#daa520" />
    <stop offset="75%" stopColor="#b8860b" />
    <stop offset="100%" stopColor="#8b6914" />
  </linearGradient>
);

const MIRROR_GRADIENT = (
  <linearGradient id="mirror-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
    <stop offset="0%" stopColor="rgba(30, 30, 30, 0.4)" />
    <stop offset="25%" stopColor="rgba(20, 20, 20, 0.5)" />
    <stop offset="50%" stopColor="rgba(10, 10, 10, 0.6)" />
    <stop offset="75%" stopColor="rgba(20, 20, 20, 0.5)" />
    <stop offset="100%" stopColor="rgba(30, 30, 30, 0.4)" />
  </linearGradient>
);

const INNER_LIGHT = (
  <linearGradient id="inner-light" x1="0%" y1="0%" x2="100%" y2="100%">
    <stop offset="0%" stopColor="rgba(255,255,255,0.4)" />
    <stop offset="50%" stopColor="rgba(255,255,255,0.1)" />
    <stop offset="100%" stopColor="rgba(0,0,0,0.2)" />
  </linearGradient>
);

const LogoText = ({ text }) => {
  return (
    <h1 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <svg
        width="280"
        height="75"
        viewBox="0 0 420 90"
        style={{ margin: '0 1rem', minWidth: 260 }}
      >
        <defs>
          {GOLD_GRADIENT}
          {MIRROR_GRADIENT}
          {INNER_LIGHT}
          <filter id="inner-lighting" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="0.5" result="blur" />
            <feComposite in="SourceGraphic" in2="blur" operator="over" />
          </filter>
          <filter id="mirror-glow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="0.5" result="blur" />
            <feComposite in="SourceGraphic" in2="blur" operator="over" />
            <feColorMatrix
              type="matrix"
              values="1 0 0 0 0.1
                      0 1 0 0 0.1
                      0 0 1 0 0.1
                      0 0 0 0.8 0"
              result="mirror-effect"
            />
          </filter>
        </defs>
        {/* Dark mirror border */}
        <path
          d="M 60,10 
             L 360,10 
             L 400,45 
             L 360,80 
             L 60,80 
             L 20,45 
             Z"
          fill="none"
          stroke="url(#mirror-gradient)"
          strokeWidth="8"
          filter="url(#mirror-glow)"
          style={{
            filter: 'brightness(1)',
          }}
          strokeLinejoin="round"
          strokeLinecap="round"
        />
        {/* Main border */}
        <path
          d="M 60,10 
             L 360,10 
             L 400,45 
             L 360,80 
             L 60,80 
             L 20,45 
             Z"
          fill="#000"
          stroke="url(#gold-gradient)"
          strokeWidth="4"
          filter="url(#inner-lighting)"
          style={{
            filter: 'brightness(1.1)',
          }}
          strokeLinejoin="round"
          strokeLinecap="round"
        />
        {/* Inner lighting overlay */}
        <path
          d="M 60,10 
             L 360,10 
             L 400,45 
             L 360,80 
             L 60,80 
             L 20,45 
             Z"
          fill="url(#inner-light)"
          opacity="0.6"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
        {/* Left Dot with inner lighting */}
        <circle
          cx="52"
          cy="45"
          r="4"
          fill="url(#gold-gradient)"
          stroke="#ffd700"
          strokeWidth="1"
          filter="url(#inner-lighting)"
        />
        <circle
          cx="52"
          cy="45"
          r="4"
          fill="url(#inner-light)"
          opacity="0.4"
        />
        {/* Right Dot with inner lighting */}
        <circle
          cx="368"
          cy="45"
          r="4"
          fill="url(#gold-gradient)"
          stroke="#ffd700"
          strokeWidth="1"
          filter="url(#inner-lighting)"
        />
        <circle
          cx="368"
          cy="45"
          r="4"
          fill="url(#inner-light)"
          opacity="0.4"
        />
        {/* Text with inner lighting */}
        <text
          x="50%"
          y="56%"
          textAnchor="middle"
          dominantBaseline="middle"
          fontFamily="'Cormorant Garamond', 'Garamond', serif"
          fontWeight="600"
          fontSize="38"
          fill="url(#gold-gradient)"
          filter="url(#inner-lighting)"
          style={{
            textTransform: 'uppercase',
            letterSpacing: '5px',
            fontStyle: 'normal',
            textShadow: '1px 1px 0 rgba(139, 105, 20, 0.8)'
          }}
        >
          {text}
        </text>
        {/* Text inner lighting overlay */}
        <text
          x="50%"
          y="56%"
          textAnchor="middle"
          dominantBaseline="middle"
          fontFamily="'Cormorant Garamond', 'Garamond', serif"
          fontWeight="600"
          fontSize="38"
          fill="url(#inner-light)"
          opacity="0.3"
          style={{
            textTransform: 'uppercase',
            letterSpacing: '5px',
            fontStyle: 'normal'
          }}
        >
          {text}
        </text>
      </svg>
    </h1>
  );
};

export default LogoText; 
